var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystalsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.94831 0.109237L0.0746232 8.43785C-0.122455 8.77779 0.0906025 9.227 0.447474 9.227H10.2694C10.328 9.227 10.3653 9.14809 10.3333 9.09345L5.07614 0.109237C5.04419 0.0606741 4.98027 0.0606741 4.94831 0.109237Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 9.34843L16.6398 0.121399H5.84314L11.2441 9.34843Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7026 9.34843L29.0983 0.121399H18.3016L23.7026 9.34843Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4708 0L12.0751 9.22703H22.8718L17.4708 0Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9292 0L24.5336 9.22703H34.6218C34.9254 9.22703 35.1065 8.8446 34.9361 8.55929L29.9292 0Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8901 29.8664L11.031 9.83405H0.68708C0.303577 9.83405 0.101172 10.3561 0.362168 10.6778L16.8901 29.8664Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9554 29.8664L24.3472 9.83405H34.6378C34.8988 9.83405 35.0373 10.1922 34.8562 10.4107L17.9554 29.8664Z",
    fill: "#C0B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4707 30L23.8145 9.83405H11.5637L17.4707 30Z",
    fill: "#C0B9F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_1965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalsIcon);
export default __webpack_public_path__ + "static/media/crystals-icon.4af7929b7900c80d81d90ecd6066a725.svg";
export { ForwardRef as ReactComponent };